import { useMutation, useQueryClient } from '@tanstack/react-query';
import costCategoriesApi from '@/features/dashboard/costCategories/api/costCategoriesApi.ts';
import { costCategoriesApiQueryKeys } from '@/features/dashboard/costCategories/api/costCategoriesApi.queryKeys.ts';
import { toast } from 'sonner';

export default function useDeleteCostCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => costCategoriesApi.remove(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({
        queryKey: costCategoriesApiQueryKeys.all(),
        // Wiersz usuniętej kategorii wisi jeszcze na ekranie, dopóki nie wróci
        // lista, więc jej zapytanie o użycie odświeżyłoby się na 404.
        predicate: (query) => query.queryKey[1] !== id,
      });
      toast.success('Kategoria kosztów została usunięta');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas usuwania kategorii kosztów.',
      });
    },
  });
}
